// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".status[data-v-dd77d548]{background:var(--main-action-green);border-radius:10px;color:var(--background-color-base);font-size:12px;padding:10px;text-align:center}.status.error[data-v-dd77d548]{background:var(--main-action-red)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
